import React, { useMemo } from 'react'
import { BrowserRouter, MemoryRouter } from 'react-router-dom'
import Routes from './routes'
import Navigation from '../components/Navigation'
import cx from 'classnames'
import styles from '../App.module.css'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../contexts/AuthContext'
const isLive = process.env.REACT_APP_MODE === 'production'
const sidebar = process.env.REACT_APP_SIDEBAR === '1'

const Router: React.FC = () => {
    const { t } = useTranslation(['nav'])
    const { role } = useAuth()

    const navigationElements = useMemo(
        () =>
            role === 'admin'
                ? [
                    { label: t('Emails'), path: '/emails' },
                    { label: 'Kunden', path: '/customers' },
                    { label: 'Branchen', path: '/types' },
                    { label: 'Einstellungen', path: '/settings' },
                ]
                : [],
        [t, role]
    )

    return isLive ? (
        <MemoryRouter>
            <div
                className={cx(
                    styles['zr-main-container'],
                    !sidebar && styles['zr-topbar']
                )}
            >
                <Navigation sidebar={sidebar} elements={navigationElements} />
                <div className={cx(styles['zr-main-content'])}>
                    <Routes />
                </div>
            </div>
        </MemoryRouter>
    ) : (
        <BrowserRouter>
            <div
                className={cx(
                    styles['zr-main-container'],
                    !sidebar && styles['zr-topbar']
                )}
            >
                <Navigation sidebar={sidebar} elements={navigationElements} />
                <div className={cx(styles['zr-main-content'])}>
                    <Routes />
                </div>
            </div>
        </BrowserRouter>
    )
}

export default Router
